import { all, takeEvery, takeLeading } from 'redux-saga/effects';
import { Types } from '../header';
import * as Layers from './layers';
import * as Shoreline from './shoreline';
import * as ShoreR from './shoreR';

const root = function* () {
  yield all([
    takeLeading(Types.LOAD_LAYER, Layers.handleLoadLayer),
    takeEvery(Types.TOGGLE_VISIBILITY, Layers.handleToggleVisibility),
    takeEvery(Types.UPDATE_OPACITY, Layers.handleUpdateOpacity),
    takeEvery(Types.REMOVE_LAYER, Layers.handleRemoveLayer),
    takeLeading(Types.IMAGE_SELECTION, Shoreline.handleImageSelection),
    takeLeading(Types.PERFORM_ANALYSIS, Shoreline.performAnalysis),
    takeLeading(Types.RESTART_ANALYSIS, Shoreline.handleRestartAnalysis),
    takeLeading(Types.PERFORM_SHORE_R_ANALYSIS, ShoreR.performShoreRAnalysis),
    takeLeading(Types.PERFORM_SHORE_R_ANALYSIS_COMMIT, ShoreR.performShoreRAnalysisCommit),
    takeLeading(Types.SELECT_SHORELINES_FOR_VIZ, Shoreline.handleSelectShorelinesForViz),
  ]);
};

export default root;
